module.exports = __webpack_public_path__ + "static/media/checked_icon.aac2c0c4.svg";